import { inject, ref } from "vue";

export default function reusableSwal() {
  const Swal = inject("$swal");
  const hotlines = ref(`Telephone Nos.: (02) 8528-0480;,
Mobile Nos: 0922-822-1033 to 35; 0917-8518645; 0998-5869439`);
  const alertMessageLapsed = () => {
    Swal.fire({
      icon: "info",
      title: "AMAP Notice",
      html: `
    We're unable to proceed with your request at this time.<br>
    For further assistance, please call <a href="tel:1234567890">IWC Hotline</a>(A1).<br>
    <strong>${hotlines.value}</strong>
  `,
      confirmButtonText: "OK",
      confirmButtonColor: "#3b82f6", // info blue
    });
  };
  const alertMessageInsufficientBalance = () => {
    Swal.fire({
      icon: "info",
      title: "AMAP Notice",
      html: `
    We're unable to proceed with your request at this time.<br>
    For further assistance, please call <a href="tel:1234567890">IWC Hotline</a>(A2).<br>
    <strong>${hotlines.value}</strong>
  `,
      confirmButtonText: "OK",
      confirmButtonColor: "#3b82f6", // info blue
    });
  };
  const alertMessageUnverified = (provider) => {
    Swal.fire({
      icon: "info",
      title: "AMAP Notice",
      html: `
  You have an existing transaction with <strong>${provider}</strong> that is still pending verification.
  Please cancel the existing transaction before generating a new one with this provider.
`,
      confirmButtonText: "OK",
      confirmButtonColor: "#3b82f6",
    });
  };

  return {
    alertMessageLapsed,
    alertMessageInsufficientBalance,
    alertMessageUnverified,
    hotlines,
  };
}
